import React from 'react';
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import webservice, {axiosErrorHandler} from "./Webservice";
import {AjaxSpinner} from "@utahdts/dts-react-common";
import {isEmpty} from "lodash";

const propTypes = {
	// the current logged in user must have all these roles
	requiredRoles: PropTypes.arrayOf(PropTypes.string),

	// the current logged in user must have one of these roles
	anyRole: PropTypes.arrayOf(PropTypes.string),

	// use a function to render children so that it only creates React components if it needs to
	children: PropTypes.func.isRequired,

	// the oidc object containing user information
	user: PropTypes.object,

	// the account from the webservice (roles)
	userAccount: PropTypes.object.isRequired,
};

const defaultProps = {
	requiredRoles: [],
	anyRole: [],
	user: { },
};

const mapStateToProps = (state) => {
	return {
		user: state.user,
		userAccount: state.userAccount
	};
};

class SecuredContent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isAjaxing: true
		};
	}

	componentDidMount() {
		if (!isEmpty(this.props.user)) {
			webservice.admin.user.get().then(() => this.setState({isAjaxing: false})).catch(error => {
				axiosErrorHandler(error, true);
			});
		}
	}

	isSecure() {
		return this.props.user && this.props.userAccount.roleName;
	}

	render() {
		return this.state.isAjaxing
			? <AjaxSpinner backdropType={AjaxSpinner.BACKDROPS.COVER_PAGE}/>
			: this.isSecure()
				? this.props.children()
				: "403: Insecure content"
			;
	}
}

SecuredContent.propTypes = propTypes;
SecuredContent.defaultProps = defaultProps;

export default connect(mapStateToProps)(SecuredContent);
